import { HandMetal, MapPin, Sparkles, Recycle } from "lucide-react";

const usps = [
  { icon: HandMetal, text: "100% Hand-Crocheted" },
  { icon: MapPin, text: "Made in Amsterdam" },
  { icon: Sparkles, text: "One of a Kind" },
  { icon: Recycle, text: "Slow Fashion" },
];

// Double the items for seamless infinite loop
const marqueeItems = [...usps, ...usps];

const USPBar = () => {
  return (
    <section className="bg-foreground py-4 border-y border-foreground overflow-hidden">
      <div className="relative flex">
        <div className="animate-marquee flex shrink-0">
          {marqueeItems.map((usp, i) => (
            <div key={i} className="flex items-center gap-2.5 mx-8 md:mx-12 shrink-0">
              <usp.icon size={14} className="text-primary-foreground/50" />
              <span className="font-body text-[11px] tracking-[0.2em] uppercase text-primary-foreground/70 whitespace-nowrap">
                {usp.text}
              </span>
              <span className="text-primary-foreground/20 mx-4">·</span>
            </div>
          ))}
        </div>
        <div className="animate-marquee flex shrink-0" aria-hidden="true">
          {marqueeItems.map((usp, i) => (
            <div key={`dup-${i}`} className="flex items-center gap-2.5 mx-8 md:mx-12 shrink-0">
              <usp.icon size={14} className="text-primary-foreground/50" />
              <span className="font-body text-[11px] tracking-[0.2em] uppercase text-primary-foreground/70 whitespace-nowrap">
                {usp.text}
              </span>
              <span className="text-primary-foreground/20 mx-4">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default USPBar;
